import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useSelector } from 'store';
import { useGetOrgQuery } from 'store/slices/apiV1/org';
import {
  CustomFieldDefinition,
  RecordTypes,
} from 'ui-component/DetailCustomFields';
import _ from 'lodash';
import { useMemo } from 'react';
import { useFeature } from '@growthbook/growthbook-react';
import { FeatureFlags } from 'types';

export default function useGetCustomFieldDefinitions({
  recordType,
}: {
  recordType: RecordTypes;
}) {
  const tempCustomProperties = useFeature(FeatureFlags.tempCustomProperties).on;
  const { activeOrg } = useSelector((state) => state.org);

  const { data: metadataOrg, isLoading: isLoadingMetadataOrg } = useGetOrgQuery(
    activeOrg?.createdFrom
      ? typeof activeOrg.createdFrom === 'string'
        ? activeOrg.createdFrom
        : activeOrg.createdFrom.id
      : skipToken
  );

  const customFieldDefinitions = useMemo(
    () =>
      tempCustomProperties
        ? []
        : (_.get(
            (metadataOrg || activeOrg)?.internalMetadata,
            ['customFields', recordType],
            []
          ) as CustomFieldDefinition[]),
    [metadataOrg, activeOrg, tempCustomProperties]
  );

  return {
    isFetching: isLoadingMetadataOrg,
    customFieldDefinitions,
  };
}
